import { Component } from '@angular/core';
import * as $ from 'jquery'
//import { DocumentoService } from '../../services/documento.service';
@Component({
    selector: "page-tabs",
    templateUrl: "./tabs.component.html"
})

export class TabsComponent {
    public circleMenu;
    public formId
    public actualForm;
    constructor(){
    $('.nav-tabs > li a[title]');
    
    //Wizard
    $('a[data-toggle="tab"]').on('show.bs.tab',  (e) => {

        var $target = $(e.target);
    
        if ($target.parent().hasClass('disabled')) {
            return false;
        }
    });
    $(".next-step").click( (e) => {

        var $active = $('.wizard .steps .nav-tabs li.active');
        
        $active.next().removeClass('disabled');
        this.nextTab($active);

    });
    $(".prev-step").click( (e) => {

        var $active = $('.wizard .steps .nav-tabs li.active');
        this.prevTab($active);

    });
    
    $('[id^=detail-]').hide();
    $('.toggle').click(function() {
        var $input = $( this );
        var $target = $('#'+$input.attr('data-toggle'));
        $target.slideToggle();
    });	

    this.circleMenu =[
        {
           "number": 1,
           "icon": "glyphicon glyphicon-home",
           "active": "active" 
        },
        {
            "number": 2,
            "icon": "glyphicon glyphicon-folder-open",
            "active": "disabled"
        },
        {
            "number": 3,
            "icon": "glyphicon glyphicon-list-alt",
            "active": "disabled"
        },
        {
            "number": 4,
            "icon": "glyphicon glyphicon-level-up",
            "active": "disabled"
        }]
    
}

 nextTab(elem) {
    $(elem).next().find('a[data-toggle="tab"]').click();
}
 prevTab(elem) {
    $(elem).prev().find('a[data-toggle="tab"]').click();
}

}
